export default function HeroSection() {
  return (
    <section className="relative min-h-screen bg-[#0f2044] overflow-hidden">
      {/* Background gradient elements */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-[#2563eb]/15 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3" />
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-[#2563eb]/8 rounded-full blur-3xl translate-y-1/2 -translate-x-1/3" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 pt-24 pb-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <h1 className="text-4xl md:text-5xl lg:text-[52px] font-bold text-white leading-tight mb-6">
              Abra sua empresa nos EUA com{" "}
              <span className="text-[#60a5fa]">suporte humano e personalizado</span>
            </h1>

            <p className="text-white/70 text-lg leading-relaxed mb-8 max-w-lg">
              Aqui você fala com pessoas reais que entendem o seu caso. Nossa equipe tem
              experiência contábil no Brasil e nos EUA — conhecemos os dois sistemas de dentro
              e orientamos você de forma direta, sem processos automatizados nem respostas genéricas.
            </p>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-3 mb-10">
              <a
                href="#abrir-empresa"
                className="bg-[#2563eb] hover:bg-[#1d4ed8] text-white font-semibold px-7 py-3.5 rounded-full transition-colors cursor-pointer text-center whitespace-nowrap text-sm"
              >
                Abrir minha empresa agora
              </a>
              <a
                href="#saiba-mais"
                className="bg-white/10 hover:bg-white/20 text-white font-semibold px-7 py-3.5 rounded-full transition-colors cursor-pointer text-center whitespace-nowrap text-sm border border-white/20"
              >
                Já tenho uma empresa →
              </a>
            </div>

            {/* Trust indicators */}
            <div className="flex flex-wrap items-center gap-6">
              {[
                { icon: "ri-shield-check-line", text: "100% seguro e legal" },
                { icon: "ri-timer-line", text: "Abertura em 5 dias úteis" },
                { icon: "ri-heart-line", text: "Atendimento humanizado" },
              ].map((item) => (
                <div key={item.text} className="flex items-center gap-2">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className={`${item.icon} text-[#60a5fa] text-base`} />
                  </div>
                  <span className="text-white/60 text-xs">{item.text}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right - Consultant Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/383a2daac259f2c24d6456b3f467cf18.jpg"
                alt="Consultora ZB Consulting atendendo cliente"
                className="w-full h-auto object-top rounded-2xl"
              />
              {/* Floating card 1 */}
              <div className="absolute top-4 left-4 bg-white rounded-xl px-3 py-2 flex items-center gap-2">
                <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
                  <i className="ri-building-line text-[#1d4ed8] text-sm" />
                </div>
                <div>
                  <p className="text-[10px] text-gray-400">Empresa aberta em</p>
                  <p className="text-xs font-bold text-[#0f2044]">5 dias úteis</p>
                </div>
              </div>
              {/* Floating card 2 */}
              <div className="absolute bottom-4 right-4 bg-white rounded-xl px-3 py-2 flex items-center gap-2">
                <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
                  <i className="ri-user-heart-line text-[#1d4ed8] text-sm" />
                </div>
                <div>
                  <p className="text-[10px] text-gray-400">Atendimento</p>
                  <p className="text-xs font-bold text-[#0f2044]">100% humanizado</p>
                </div>
              </div>
            </div>

            {/* Decorative dots */}
            <div className="absolute -bottom-6 -left-6 w-24 h-24 opacity-20">
              <div className="grid grid-cols-5 gap-1.5">
                {Array.from({ length: 25 }).map((_, i) => (
                  <div key={i} className="w-1.5 h-1.5 bg-[#2563eb] rounded-full" />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
